import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import './SiteHeader.css';

// 메뉴 정의 — 라우트는 여기 한 곳만 고치면 헤더·푸터가 같이 따라간다
export const MENU = [
  {
    label: { ko: '회사소개', en: 'About Us' },
    items: [
      { to: '/about/greeting', label: { ko: '인사말',   en: 'Greeting' } },
      { to: '/about/history',  label: { ko: '연혁',     en: 'History' } },
      { to: '/about/location', label: { ko: '오시는길', en: 'Location' } },
    ],
  },
  {
    label: { ko: 'ML-CARE 솔루션', en: 'ML-CARE Solution' },
    items: [
      { to: '/solution/intro',     label: { ko: '스마트 기저귀 소개', en: 'Smart Diaper' } },
      { to: '/solution/structure', label: { ko: '작동 구조',         en: 'How It Works' } },
      { to: '/solution/features',  label: { ko: '주요 기능',         en: 'Key Features' } },
    ],
  },
  {
    label: { ko: '소식 자료', en: 'News' },
    items: [
      { to: '/news/press', label: { ko: '보도 자료', en: 'Press' } },
      { to: '/news/media', label: { ko: '홍보 자료', en: 'Media' } },
    ],
  },
  {
    label: { ko: '고객 센터', en: 'Support' },
    items: [
      // 공지사항은 기존 페이지가 이미 있다
      { to: '/notice',          label: { ko: '공지 사항',      en: 'Notices' } },
      { to: '/support/faq',     label: { ko: '자주 묻는 질문', en: 'FAQ' } },
      { to: '/support/inquiry', label: { ko: '1:1 문의',       en: 'Contact Us' } },
    ],
  },
];

const Chev = () => (
  <svg className="chev" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path d="m6 9 6 6 6-6" />
  </svg>
);

function SiteHeader() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(null);      // 열린 GNB 인덱스
  const [langOpen, setLangOpen] = useState(false);
  const ref = useRef(null);

  // 바깥 클릭 · Esc 로 닫는다 (hover 만으로는 터치 기기에서 닫히지 않는다)
  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) { setOpen(null); setLangOpen(false); }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') { setOpen(null); setLangOpen(false); }
    };
    document.addEventListener('pointerdown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  const close = () => { setOpen(null); setLangOpen(false); };

  return (
    <header className="sh" ref={ref}>
      {/* 배경·아래 테두리는 화면 전체, 내용만 본문 격자에 맞춘다 */}
      <div className="sh-inner">
      {/* 메인에 있을 때 로고를 누르면 맨 위로 올린다(라우터만으로는 스크롤이 안 움직인다) */}
      <Link className="sh-logo" to="/" onClick={() => {
        close();
        if (window.location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
      }}>
        <img src={process.env.PUBLIC_URL + '/medilogis_logo.png'} alt="" />
        <span>MEDILOGIS</span>
      </Link>

      <nav className="sh-nav" aria-label={lang === 'en' ? 'Main menu' : '주 메뉴'}>
        <ul className="sh-gnb">
          {MENU.map((m, i) => (
            <li key={i} className={open === i ? 'open' : ''}>
              <button
                type="button"
                className="sh-link"
                aria-expanded={open === i}
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span>{m.label[lang]}</span>
                <Chev />
              </button>
              <div className="sh-drop">
                {m.items.map((it) => (
                  <Link key={it.to} to={it.to} onClick={close}>{it.label[lang]}</Link>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </nav>

      <div className={`sh-lang ${langOpen ? 'open' : ''}`}>
        <button
          type="button"
          className="sh-lang-btn"
          aria-expanded={langOpen}
          onClick={() => setLangOpen(!langOpen)}
        >
          {lang === 'en' ? 'EN' : 'KR'}
          <Chev />
        </button>
        <div className="sh-lang-menu">
          <button type="button" className={lang === 'ko' ? 'on' : ''}
                  onClick={() => { setLang('ko'); setLangOpen(false); }}>KR 한국어</button>
          <button type="button" className={lang === 'en' ? 'on' : ''}
                  onClick={() => { setLang('en'); setLangOpen(false); }}>English</button>
        </div>
      </div>
      </div>
    </header>
  );
}

export default SiteHeader;
